import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Form, Button, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import Swal from "sweetalert2";
import { BASE_URL } from '../../App';

const { Option } = Select;

//const GOOGLE_MAPS_API_KEY = "sdfsdsfsdfsdffsdfsdfxfvdfdsdfsdfsdffg";
const GOOGLE_MAPS_API_KEY = "AIzaSyCJR-y0wvVJv90jeoPlyt5btMYlORR3P80";

const mapContainerStyle = {
  width: "100%",
  height: "500px",
  borderRadius: "10px",
};

const center = {
  lat: 20.5937,
  lng: 78.9629,
};

const DealerPincodeMap = () => {
  const mapRef = useRef(null);
  const markersRef = useRef([]);
  const infoWindowRef = useRef(null);
  const [map, setMap] = useState(null);
  const [form] = Form.useForm();
  const [filteredData, setFilteredData] = useState([]);
  const [dealers, setDealers] = useState([]);
  
  const dealercode = localStorage.getItem("USER_ID");
  
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  });

  const pincodeCache = {};
  const getLatLngFromPincode = async (pincode) => {
    if (pincodeCache[pincode]) return pincodeCache[pincode];

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode},India&key=${GOOGLE_MAPS_API_KEY}`
      );
      const data = await response.json();
      if (data.status === "OK" && data.results.length > 0) {
        const location = data.results[0].geometry.location;
        pincodeCache[pincode] = location;
        return location;
      } else {
        Swal.fire("Error", "Invalid Pincode or API quota exceeded", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Failed to fetch location", "error");
    }
    return null;
  };

  useEffect(() => {
    if (!isLoaded || !mapRef.current || map) return;

    const mapInstance = new window.google.maps.Map(mapRef.current, {
      center: center,
      zoom: 5,
      zoomControl: true,
    });
    setMap(mapInstance);
  }, [isLoaded, map]);

  useEffect(() => {
  if (!map) return;

  // ✅ STEP 1: Remove all existing markers before adding new ones
  markersRef.current.forEach((marker) => {
    marker.setMap(null); // Remove marker from map
  });
  markersRef.current = []; // Reset marker references

  if (!infoWindowRef.current) {
    infoWindowRef.current = new window.google.maps.InfoWindow();
  }

  if (filteredData.length === 0) return; // No new markers to add

  const locationCounts = {};
  const getLocationKey = (lat, lng) => `${lat},${lng}`;

  Promise.all(
    filteredData.map(async (poi) => {
      const location = await getLatLngFromPincode(poi.pincode);
      if (location) {
        const key = getLocationKey(location.lat, location.lng);
        if (!locationCounts[key]) {
          locationCounts[key] = { ...location, pincode: poi.pincode, count: 0 };
        }
        locationCounts[key].count += 1;
      }
    })
  ).then(() => {
	  
	  const locations = Object.values(locationCounts);
    
    if (locations.length > 0) {
      // **Set the map center to the first received location**
      const firstLocation = locations[0];
      map.setCenter({ lat: firstLocation.lat, lng: firstLocation.lng });
      map.setZoom(12); // Adjust zoom level as needed
    }
	
    locations.forEach(({ lat, lng, count, pincode }) => {
      const marker = new window.google.maps.Marker({
        position: { lat, lng },
        map: map,
        label: {
          text: count.toString(),
          color: "white",
          fontSize: "12px",
          fontWeight: "bold",
        },
      });

      marker.addListener("click", () => {
        infoWindowRef.current.setContent(
          `<b>Pincode:</b> ${pincode}<br><b>Count:</b> ${count}`
        );
        infoWindowRef.current.open(map, marker);
      });

      markersRef.current.push(marker); // ✅ Add new markers
    });
  });
}, [map, filteredData]);



  const handleFormSubmit = async (values) => {
	  setFilteredData([]);
    try {
      const formDataObject = new FormData();
      formDataObject.append("dealers", values.dealers);
      formDataObject.append("user", dealercode);
      formDataObject.append("type", 'dealer_rijen');

      const response = await axios.post(BASE_URL + "/map_pincode_data", formDataObject);

      if (response.data && response.data.data) {
        setFilteredData(response.data.data);
      } else {
        setFilteredData([]);
        Swal.fire("Warning", "No data found!", "warning");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "API Error",
        text: error.response?.data?.message || "Something went wrong",
      });
    }
  };

  useEffect(() => {
    axios.get(BASE_URL + "/dealer_name_list").then((res) => {
      setDealers(res.data.data);
    }).catch((err) => {
      console.log(err);
    });
  },[]);

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Maps...</div>;

  return (
    <>
      <div className="mt-5 ms-5 me-5">
        <center>
          <h3 className="text-danger">Dealer Pincode Mapping</h3>
        </center>
        <br />
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFormSubmit}
          initialValues={{
            fromDate: "",
            toDate: "",
          }}
        >
          <div className="row">
            <div className="col-md-4">
              <Form.Item
                label={<b className="text-danger">Dealers :</b>}
                name="dealers"
                className="bold-label"
                rules={[{ required: true, message: "Please input Dealers!" }]}>
                <Select
                  showSearch
                  placeholder="Select Dealers"
                  allowClear
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                  }>
                  {dealers.length > 0 ? (
                    dealers.map((dealer) => (
                      <Option key={dealer.DEALER_CODE} value={dealer.DEALER_CODE} label={dealer.DEALERNAME}>
                        {dealer.DEALERNAME}
                      </Option>
                    ))
                  ) : (
                    <></>
                  )}
                </Select>
              </Form.Item>
            </div>

            <div className="col-md-4 mt-4">
              <Button
                type="primary"
                style={{ backgroundColor: "#FF4D4F", borderColor: "#FF4D4F" }}
                shape="round"
                icon={<SearchOutlined />}
                htmlType="submit"
                className="w-100"
              >
                Search
              </Button>
            </div>
          </div>
        </Form>
      </div>

      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={filteredData.length > 0 && markersRef.current.length > 0
          ? markersRef.current[0]?.getPosition() || center
          : center}
        zoom={filteredData.length > 0 ? 12 : 5}
        onLoad={(map) => setMap(map)}
      >
        {markersRef.current.length > 0 &&
          markersRef.current.map((marker, index) => (
            <Marker key={index} position={marker.getPosition()} />
          ))}
      </GoogleMap>
    </>
  );
};

export default DealerPincodeMap;
